var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92191 5.564C9.6694 6.45938 8.47628 7.092 6.08989 8.35738C3.78289 9.58063 2.62938 10.1923 1.69988 9.94638C1.31558 9.84475 0.965428 9.65175 0.683039 9.38575C-4.47036e-07 8.74263 0 7.49513 0 5C0 2.50488 -4.47036e-07 1.2574 0.683039 0.614215C0.965428 0.348302 1.31558 0.155264 1.69988 0.0536141C2.62938 -0.192236 3.78289 0.419389 6.08989 1.64261C8.47628 2.908 9.6694 3.54063 9.92191 4.436C10.026 4.80563 10.026 5.19438 9.92191 5.564Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.20c2cc301ae80e27de4b41200adb391e.svg";
export { ForwardRef as ReactComponent };